import { createSlice } from '@reduxjs/toolkit';

const mediaMessageSlice = createSlice({
  name: 'mediaMessage',
  initialState: {
    loading: false,
    error: null,
  },
  reducers: {
    sendMediaMessageRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    sendMediaMessageSuccess: (state) => {
      state.loading = false;
      state.error = null;
    },
    sendMediaMessageFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  sendMediaMessageRequest,
  sendMediaMessageSuccess,
  sendMediaMessageFailure,
} = mediaMessageSlice.actions;

export const selectMediaMessageLoading = (state) => state.mediaMessage?.loading || false;
export const selectMediaMessageError = (state) => state.mediaMessage?.error || null;

export default mediaMessageSlice.reducer;
